module.exports = __webpack_public_path__ + "static/media/preview_image_DELETE4.7fe179a0.png";